import React, { Component } from 'react';
import { Style } from 'radium';
import listensToClickOutside from 'react-onclickoutside';
import classNames from 'classnames';
import Icon from '../helper/Icon';

class SideMenuSlider extends Component {
  static styles = {};

  handleClickOutside(e) {
    //  this.props.open && this.props.closeSideMenu && this.props.closeSideMenu();
  }

  render() {
    const styles = SideMenuSlider.styles;
    const {
      side,
      children,
      style,
      contentContainerStyle,
      closeSideMenu,
      open,
      closeButtonStyle,
      closeIconColor
    } = this.props;
    const slideClasses = classNames('SideMenuSlider', {
      rightSide: side === 'right',
      leftSide: !side || side === 'left',
      open: !!open
    });
    const closeButtonClasses = classNames('closeButton', {
      right: side === 'right',
      left: !side || side === 'left'
    });
    const overlayClasses = classNames('clickBlockOverlay', { visible: !!open });

    return (
      <div className="SideMenuSliderContainer">
        <div className={overlayClasses} onClick={closeSideMenu} />
        <div className={slideClasses} style={style}>
          <div className={closeButtonClasses} style={closeButtonStyle} onClick={closeSideMenu}>
            <Icon icon="close" fill={closeIconColor || '#313537'} size="20px" />
          </div>
          <div className="contentContainer" style={contentContainerStyle}>
            {children}
          </div>
        </div>
        <Style rules={styles.classBased} scopeSelector=".SideMenuSliderContainer" />
      </div>
    );
  }
}

SideMenuSlider.styles = {
  classBased: {
    '': {
      position: 'absolute',
      top: '-10px',
      right: '-10px',
      height: '1px',
      width: '1px',
      background: 'transparent'
    },
    '.SideMenuSlider': {
      width: '500px',
      position: 'fixed',
      top: 0,
      bottom: 0,
      background: '#fff',
      zIndex: 1001,
      overflow: 'auto'
    },
    '.SideMenuSlider.rightSide': {
      right: 0,
      transform: 'translate3d(100%,0,0)',
      transition:
        'transform .66s cubic-bezier(.77,0,.175,1), -webkit-transform .66s cubic-bezier(.77,0,.175,1)'
    },
    '.SideMenuSlider.leftSide': {
      left: 0,
      transform: 'translate3d(-100%,0,0)',
      transition:
        'transform .66s cubic-bezier(.77,0,.175,1), -webkit-transform .66s cubic-bezier(.77,0,.175,1)'
    },
    '.SideMenuSlider.open': {
      transform: 'translateZ(0)'
    },
    '.closeButton': {
      position: 'absolute',
      top: '20px',
      height: '20px',
      width: '20px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    },
    '.closeButton.right': {
      left: '20px',
      position: 'sticky',
      zIndex: '1005',
      top: '0',
      width: '100%',
      paddingRight: '448px',
      backgroundColor: 'white',
      height: '25px',
      paddingTop: '20px',
      paddingBottom: '10px'
    },
    '.closeButton.left': {
      right: '20px'
    },
    '.contentContainer': {
      padding: '15px 25px'
    },
    '.clickBlockOverlay': {
      position: 'fixed',
      top: '0px',
      left: '0px',
      right: 'auto',
      bottom: 'auto',
      opacity: '0.001',
      backgroundColor: 'rgba(0,0,0,0.1)',
      transition: 'opacity .66s cubic-bezier(.77,0,.175,1)'
    },
    '.clickBlockOverlay.visible': {
      opacity: '1',
      right: '0px',
      bottom: '0px',
      zIndex: '101'
    }
  }
};

export default listensToClickOutside(SideMenuSlider);
